<template>
  <v-card
    elevation="0"
    color="wrld_background"
  >
    <v-card-title
      v-if="!isDialog"
    >
      <span class="headline">{{ title }}</span>
    </v-card-title>
    <v-list
      flat
      class="attachments--files--list"
      :color="isDialog ? null : 'wrld_background'"
    >
        <v-list-item-group
          v-if="!isLoading"
        >
          <template
            v-for="({ filename, s3Key }) in attachmentsList"
          >
            <v-list-item
              :key="s3Key"
              @click="handleFileClick(s3Key)"
            >
            <v-list-item-avatar>
              <v-icon
                size="16"
                class="wrld_grey white--text"
              >
                fas fa-file-alt
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ filename }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-container
                class="pa-0"
                fluid
              >
                <v-row
                  no-gutters
                  align="center"
                  justify="space-between"
                >
                  <v-col
                    cols="auto"
                    class="mr-1"
                  >
                    <v-tooltip
                      top
                    >
                      <template
                        v-slot:activator="{ on }"
                      >
                        <v-icon
                          v-on="on"
                          size="16"
                          v-if="s3KeyDownloading !== s3Key"
                        >
                        fas fa-cloud-download-alt
                        </v-icon>
                        <v-icon
                          v-on="on"
                          size="16"
                          v-else
                        >
                        fas fa-spinner fa-spin
                        </v-icon>
                      </template>
                      <span>{{ $t(`attachments.download`) }}</span>
                    </v-tooltip>

                  </v-col>
                  <v-col
                  >
                    <v-dialog
                      v-model="deleteDialog"
                      max-width="350"
                    >
                      <template
                        v-slot:activator="{ on: dialog }"
                      >
                        <v-tooltip
                          top
                          >
                          <template
                            v-slot:activator="{ on: tooltip }"
                          >
                            <v-icon
                              v-on.stop="{...dialog, ...tooltip}"
                              size="18"
                            >
                            fas fa-times
                            </v-icon>
                          </template>
                          <span>{{ $t(`buttons.delete`) }}</span>
                        </v-tooltip>
                      </template>
                      <v-card>
                        <v-card-title class="headline">
                          {{ $t('attachments.confirm_delete_title') }}
                        </v-card-title>
                        <v-card-text>
                         <i18n
                            path="attachments.confirm_delete_message"
                            tag="span"
                          >
                            <span>
                              {{ filename }}
                            </span>
                          </i18n>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="wrld_grey" depressed @click="deleteDialog = false">
                            {{ $t('buttons.cancel') }}
                          </v-btn>
                          <v-btn color="wrld_red" dark depressed @click="handleFileDelete(s3Key)">
                            {{ $t('buttons.delete') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-list-item-action>
            </v-list-item>
            <v-divider
              :key="`${s3Key}_divider`"
            ></v-divider>
          </template>
        </v-list-item-group>
        <v-list-item-group
          active-class="wrld_grey--text"
          v-else
        >
          <v-skeleton-loader
            class="mx-auto"
            type="list-item-avatar-two-line"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            type="list-item-avatar-two-line"
          ></v-skeleton-loader>
        </v-list-item-group>
      </v-list>
  </v-card>
</template>

<script>
  export default {
    name: "AttachmentsFilesList",
    props: {
      isLoading: { type: Boolean, default: true },
      attachmentsList: { type: Array, default: null },
      activatorText: { type: String, default: null },
      title: { type: String, default: null},
      isDialog: { type: Boolean, default: false },
      s3KeyDownloading: { type: String | Boolean, default: null }
    },
    data () {
      return {
        deleteDialog: false
      }
    },
    methods: {
      handleFileClick (s3Key) {
        this.$emit('download', s3Key)
      },
      handleFileDelete (s3Key) {
        this.$emit('delete', s3Key)
        this.deleteDialog = false
      }
    }
  }
</script>

<style lang="scss" scoped>
.attachments--files--list {
  max-height: 200px;
  overflow-y: auto;
}

</style>
